/**
 * @file index.tsx
 *
 * @fileoverview Renders link referring to the font styles file.
 */
import localFont from 'next/font/local';
import { Source_Sans_3 } from 'next/font/google';

const ceraPro = localFont({
  src: [
    {
      path: './../../../../../public/fonts/woff2/Cera_Pro_Bold.woff2',
      weight: '700',
      style: 'normal',
    },
  ],
});

const sourceSans3 = Source_Sans_3({
  weight: ['300', '400', '700', '900'],
  style: ['normal'],
  subsets: ['latin'],
  display: 'swap',
});

export const NextFontSlot = ({ children }) => (
  <div>
    {children}
    <style jsx global>{`
      :root {
        --font-family-body: ${sourceSans3.style.fontFamily};
        --font-family-headings: ${ceraPro.style.fontFamily};
      }
    `}</style>
  </div>
);
